import { generateClient } from "aws-amplify/api";
import {
  getClassSuperData,
  getClassSuperDetails,
  getClassSuperFormData,
} from "../graphql/queries";

const client = generateClient();

const classSuperService = {
  getClassSuperDetails: async () => {
    const response = await client.graphql({
      query: getClassSuperDetails,
      variables: {},
      authMode: "iam",
    });

    return JSON.parse(response.data.getClassSuperDetails) || [];
  },
  getClassSuperDetailsUP: async () => {
    const response = await client.graphql({
      query: getClassSuperDetails,
      variables: {},
      authMode: "userPool",
    });

    return JSON.parse(response.data.getClassSuperDetails) || [];
  },
  getClassSuperData: async (operation, parameters) => {
    const response = await client.graphql({
      query: getClassSuperData,
      variables: { operation, parameters: JSON.stringify(parameters) },
      authMode: "userPool",
    });

    return response.data.getClassSuperData;
  },
  getClassSuperFormData: async (fundCode, firmName, selectedFY) => {
    const response = await client.graphql({
      query: getClassSuperFormData,
      variables: {
        fundCode,
        firmName,
        selectedFY,
      },
      authMode: "userPool",
    });

    return response.data.getClassSuperFormData;
  },
};

export default classSuperService;
